//TODO: Add paging for posts that have more comments than 50... for enterprise only - manoj
import { useEffect, useState, useRef, Fragment, useContext, memo, useMemo } from "react";
import LinkedinPost from "components/tweets/masonry/linkedinPost";
import { formatTweetFromPost } from "../../../utils/linkedinUtils";
import {
    Box,
    Grid,
    Flex,
    Button,
    Tooltip,
    Text,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    useBreakpointValue
} from "@chakra-ui/react";
import PuffLoader from "react-spinners/PuffLoader";
import { TweetComposer } from "components/tweet-composer";
import { CommentView } from "./comment-view";
import { useCredit, getCreditBack, checkCredit } from "controllers/subscription";
import { getAccount } from 'utils/sessionHelper';
import { useSession } from "next-auth/react";
import { MainContext } from "context/mainContext";
import toast from "react-hot-toast";
import { TweetContext } from '../../../context/tweetContext';
import { likePost } from "controllers/miscellaneous";
import { postReply } from "../../../controllers/schedule";
import { getToken } from "../../../firebaseClient";
import { textStyle, layerStyle } from "theme/names";
import { CardList } from '../../cardList';
import { BsChevronDown } from "react-icons/bs";
import { SortType, sortValuesByMode, sortPosts } from "../utils";
import { CustomToast } from 'components/toasts/CustomToast';
import { FixedSizeList } from "react-window";
import localforage from "localforage";
import { ez4castApiUrls } from "utils/ez4cast";

const linkedinRepliesUrl = ez4castApiUrls.generateSmartReplies.prod;

const cards = [
    {
        label: "🤓 Add value",
        title: "🤓",
        key: "addValue"
    },
    {
        label: "👏 Congratulate",
        title: "👏",
        key: "congratulate"
    },
    {
        label: "🙏 Say thank you",
        title: "🙏",
        key: "thank"
    }
];

export interface CommentRepliesProps {
    data: any
    loadingComments?: boolean
    /** hides the original post from the grid and displays an icon to open the post in a modal on each comment */
    hasReducedView?: boolean
}

export const CommentReplies = ({
    data = {} as any,
    loadingComments = true,
    hasReducedView = false,
}: CommentRepliesProps) => {
    // if(!data) return null;

    const [commentsData, setCommentsData] = useState<any>(data);
    const [isLoadingComments, setIsLoadingComments] = useState<any>(loadingComments);
    const [canPostComments, setCanPostComments] = useState<boolean>(commentsData?.post?.zFull?.socialDetail?.socialPermissions?.canPostComments);
    const [isProcessing, setIsProcessing] = useState<any>(true);
    const refComposer = useRef<any>(null);

    const onSort = async (sortby = SortType.MOST_RECENT, commentsDataToSort = commentsData?.comments, commentsOfPost = commentsData?.post, updateState = true): Promise<any> => {
        if (Object.keys(commentsData).length > 0 && commentsDataToSort && commentsOfPost) {
            const sortedComments = sortPosts(commentsDataToSort, sortby);
            const sortedCommentsData = {
                post: commentsOfPost,
                comments: sortedComments
            };

            if (updateState) {
                setCommentsData(sortedCommentsData);
            }

            return sortedCommentsData;
        }
    }

    const onReply = async (comment: any, post: any, updateState = true): Promise<any> => { }; //future proof callback added for onReply events. -- manoj

    const onHide = async (comment: any, post: any, updateState = true): Promise<any> => {
        if (Object.keys(commentsData).length > 0 && commentsData.comments?.length) {
            let getHiddenCommentList: Set<any> = await localforage.getItem("hiddenRTCs") || new Set();
            if (Boolean(comment) === true) {
                getHiddenCommentList.add(comment?.id);
                await localforage.setItem('hiddenRTCs', getHiddenCommentList);
            }

            const nonHiddenComments = commentsData.comments.filter((cd) => {
                return !getHiddenCommentList.has(cd?.id);
            });

            const nonHiddenCommentsData = {
                post,
                comments: nonHiddenComments
            };

            if (updateState) {
                setCommentsData(nonHiddenCommentsData);
            }

            return nonHiddenCommentsData;

        }
    }

    const onLoadComments = async (data: any) => {
        //remove hiddent comments and sort,
        if (Object.keys(data).length > 0) {
            const nonHiddenCommentsData = await onHide(false, data?.post, false);
            const sortedCommentsData = await onSort(SortType.MOST_RECENT, nonHiddenCommentsData?.comments, nonHiddenCommentsData?.post, false);
            setCommentsData(sortedCommentsData);
        }

        setIsProcessing(false);
    }

    useEffect(
        () => {
            onLoadComments(data);
            // console.log(data, 'comments - within CR');
        }, [data]
    );

    useEffect(
        () => {
            setIsLoadingComments(loadingComments && isProcessing);
        }, [loadingComments, isProcessing]
    );

    useEffect(
        () => {
            setCanPostComments(commentsData?.post?.zFull?.socialDetail?.socialPermissions?.canPostComments);
        }, [commentsData]
    );

    const virtSizes = useBreakpointValue([750, 450]) || 450;

    const linkedInPost = useMemo(() => {
        if (commentsData?.post) {
            return <LinkedinPost
                tweet={{ data: formatTweetFromPost(commentsData?.post) }}
                disableFooter={true}
                disableEditTweet={true}
                disableCopy={true}
                disableUserPopup={true}
                disableRequest={true}
                disableBookmarkButton={true}
                disableHideButton={true}
            />
        }
        return null
    }, [commentsData?.post])

    const templateColumns = hasReducedView ? '1fr' : ['1fr', '1fr', '250px 1fr', '300px 1fr'];

    return (

        <Grid templateColumns={templateColumns} gap={3} w={'100%'} h={"100%"} sx={{
            paddingTop: '3.9rem'
        }}>
            {
                (!hasReducedView) &&
                <Box position={["relative", "sticky"]} top={3} height={"100%"} width={"100%"}>
                    {linkedInPost}
                </Box>
            }
            {
                (!isLoadingComments)
                    ?
                    ((commentsData?.comments?.length > 0)
                        ?
                        <>
                            {/* <AutoSizer>
                            {({ height, width }) => */}
                            <FixedSizeList
                                height={(virtSizes * commentsData?.comments?.length)}
                                itemCount={commentsData?.comments?.length}
                                itemSize={virtSizes}
                                width={"100%"}
                                itemData={{ commentsData, onSort, onHide, refComposer, canPostComments, onReply, hasReducedView }}
                                style={{ overflow: "visible", scroll: "none" }}
                            >

                                {virtualizedCommentComposer}

                            </FixedSizeList>

                            {/* }
                        </AutoSizer> */}
                        </>
                        :
                        (commentsData?.post &&
                            <>
                                <Text
                                    w={"100%"}
                                    textAlign={"center"}
                                    textStyle={textStyle["body.medium.light"]}
                                    fontSize="md"
                                    pt={3}
                                >
                                    You're all up to date - Congrats! 🎉
                                </Text>
                            </>
                        )
                    )
                    :
                    <PuffLoader loading={true}></PuffLoader>


                // (!isLoadingComments && commentsData?.comments?.length > 0) && (
                //     <>
                //         {/* <AutoSizer>
                //             {({ height, width }) => */}
                //         <FixedSizeList
                //             height={(virtSizes * commentsData?.comments?.length)}
                //             itemCount={commentsData?.comments?.length}
                //             itemSize={virtSizes}
                //             width={"100%"}
                //             itemData={{ commentsData, onSort, onHide, refComposer, canPostComments, onReply }}
                //             style={{ overflow: "visible", scroll: "none" }}
                //         >

                //             {virtualizedCommentComposer}

                //         </FixedSizeList>

                //         {/* }
                //         </AutoSizer> */}
                //     </>
                // )
            }
            {/* {

                (!isLoadingComments)
                    ?
                    (commentsData?.comments?.length > 0)
                        ? (commentsData.comments.map(
                            (comment, i) => {
                                return (
                                    <Fragment key={(comment.id + "_empty_" + i)}>
                                        <CommentComposer
                                            refComposer={refComposer}
                                            canPostComments={canPostComments}
                                            comment={comment} post={commentsData?.post}
                                            index={i}
                                            onSortCallback={onSort}
                                        />
                                    </Fragment>
                                )
                            }
                        ))
                        :
                        (commentsData?.post &&
                            <>
                                <Text
                                    w={"100%"}
                                    textAlign={"center"}
                                    textStyle={textStyle["body.medium.light"]}
                                    fontSize="md"
                                    pt={3}
                                >
                                    No more comments to reply to, for this post.
                                </Text>
                            </>
                        )
                    :
                    <PuffLoader loading={true}></PuffLoader>
            } */}

        </Grid >

    );
}

interface virProps {
    style: any,
    data: any,
    index: number
}

const virtualizedCommentComposer = memo((props: virProps) => {
    // console.log(props, 'v check')
    return (
        <Box style={{ ...props?.style }} key={(props.data.commentsData.comments?.[props.index].id + "_empty_" + props?.index)} marginTop={['3rem', '0rem']} >
            <CommentComposer
                refComposer={props.data?.refComposer}
                canPostComments={props.data?.canPostComments}
                comment={props.data.commentsData.comments?.[props.index]} post={props.data?.commentsData?.post}
                index={props.index}
                hasReducedView={props.data?.hasReducedView}
                onSortCallback={props.data?.onSort}
                onReplyCallback={props.data?.onReply}
                onHideCallback={props.data?.onHide}
            />
        </Box>
    )
})

const CommentComposer = ({
    refComposer,
    canPostComments = true,
    comment,
    post,
    hasReducedView,
    index,
    onSortCallback = (sortType = SortType?.MOST_RECENT) => { },
    onHideCallback = (comment: any, post: any, updateState = true) => { },
    onReplyCallback = (comment: any, post: any, updateState = true) => { }
}) => {
    const [replyTootlTip, setReplyToolTip] = useState<any>();
    const { data: session, status } = useSession() ?? {}
    const loading = status === "loading"

    const mainContext = useContext<any>(MainContext);
    const tweetContext = useContext<any>(TweetContext);
    const [isPosting, setIsPosting] = useState<boolean>(false);
    const [isReplied, setIsReplied] = useState<boolean>(false);
    // const [isHidden, setIsHidden] = useState<boolean>(false);
    const [isGenerating, setIsGenerating] = useState<boolean>(false);
    const [isGeneratingAutoReply, setIsGeneratingAutoReply] = useState<boolean>(false);
    const [sortby, setSortby] = useState(SortType.MOST_RECENT);

    const emptyBoxRef = useRef(null);

    const sendReply = async () => {
        if (checkCredit(session, mainContext, "creditsReplies", true) === false) {
            return
        }

        let text = refComposer.current.textState().text;

        if (!canPostComments) {
            toast.error(`Comments are restricted on this post`);
            return;
        }

        if (!text) {
            toast.error(`You need to write something`);
            return;
        }

        //comment length by linkedin - 1250 char
        if (text.length > 1245) {
            toast.error(`Your reply is too long`);
            return;
        }

        // // console.log(getAccount(session));

        if (!getAccount(session)?.access_token) {
            tweetContext.onOpenCredentials();
            toast.error(`No token found.`);
            return;
        }

        if (!comment?.id) {
            console.log(`idComment not found`);
            toast.error(`Replying to comment failed. Error: No id.`);
            return;
        }

        const idComment = comment?.id.replace("(activity", "(urn:li:activity");

        //@ts-ignore
        console.log("send Comment Reply: " + JSON.stringify(refComposer.current.textState()));
        let dataToSend = {
            id_str: post?.idUgcPost || post?.id_str,
            idUser: getAccount(session)?.id,
            idAccount: getAccount(session)?.idAccount,
            accessToken: getAccount(session).access_token,
            text,
            idComment,
            commentUrn: comment?.id,
        }

        let isSuccess = await postReply(setIsPosting, dataToSend, tweetContext, session);

        // when auto like is active
        if (isSuccess) {
            if (getAccount(session)?.autoLikeOnReply) {
                const likePayload = {
                    postUrn: comment?.id || post.idUgcPost || post.id_str,
                    accessToken: getAccount(session).access_token,
                    idAccount: getAccount(session).idLinkedinOfficial ?? getAccount(session).idAccount,
                    idLinkedin: getAccount(session).idLinkedin,
                }

                const data = await likePost(session, likePayload, post);

                if (data?.success) {
                    // toast.success("Post liked");
                } else {
                    toast.error("Failed to like post/comment");
                }
            }

            comment.reply = text;
            comment.isReplied = true;
            useCredit(session, mainContext, "creditsReplies")
            setIsReplied(true);
            onReplyCallback(comment, post);
            removeComment(comment);
        }
        else {
            console.log('Failed to reply to comment:', isSuccess);
            setIsReplied(false);
            getCreditBack(session, "creditsReplies");
        }



    }

    const onUpdate = async (state) => {
        // console.log("onUpdate");
        comment.reply = state?.text;
    }

    const generateReplies = async (topic) => {
        const token = await getToken(session, "aiReplies");

        // if (! await useCredit(session, mainContext))
        //   return;

        setIsGeneratingAutoReply(true);

        const useCreditBoolean = await useCredit(session, mainContext, "creditsBestai", false)

        // start toast custom
        const toastIdCustom = toast.loading(<CustomToast useCreditBoolean={useCreditBoolean} />);

        const data = {
            topic,
            idUser: session?.user?.uid as string,
            post: [{
                author: comment?.profileFullName,
                post: post?.text || "",
                comment: comment?.comment || ""
            }],
            useBestAi: useCreditBoolean,
        }
        // console.log(post);

        try {
            const res = await fetch(linkedinRepliesUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    tokenuserid: data?.idUser ?? "",
                },
                credentials: "same-origin",
                body: JSON.stringify({ ...data, isInfluentLeader: true }),
            });

            const response = await res.json()
            comment.reply = response?.data?.replies[0];

            tweetContext.setIsTweetTextChanged(true);
        } catch (error) {
            getCreditBack(session)
            console.log({ error })
            toast.error("Error generating reply please retry or contact the support");
        }

        toast.dismiss(toastIdCustom);
        setIsGeneratingAutoReply(false);

    }

    const removeComment = (comment) => {
        // setIsHidden(true);
        try {
            const nextEmptyBox = document.querySelector("#" + "emptybox_" + post?.idShort + "_" + (index + 1));
            nextEmptyBox?.remove();
        } catch {
            console.log('reply to comments: error removing empty box');
        }
        onHideCallback(comment, post);
    }

    useEffect(
        () => {
            //@ts-ignore
            setReplyToolTip(typeof window !== "undefined" && window?.navigator?.userAgentData?.platform?.includes("mac") ? "Cmd-Enter" : "Ctrl-Enter");

            if (canPostComments === false)
                setReplyToolTip("Comments are restricted on this post");
        }, []
    );

    return (
        <>
            { /*needed for grid cols */
                (index !== 0) && <Box ref={emptyBoxRef} id={"emptybox_" + post?.idShort + "_" + index}></Box>
            }
            {
                (!isReplied) &&
                <Flex
                    flexDirection={["column", "row"]}
                    gap={3}
                    w={'100%'}
                    flexWrap={"nowrap"}
                >
                    <Flex flexDirection={"column"} w={['100%', '50%']} overflow={"hidden"}>
                        <CommentView
                            post={hasReducedView ? post : null}
                            comment={comment}
                            onClickHide={
                                () => {
                                    removeComment(comment)
                                }
                            }
                        />
                    </Flex>
                    <Flex
                        flexDirection={"column"}
                        w={['100%', '50%']}
                        position={"relative"}
                    >
                        {
                            (index == 0) &&
                            <Flex
                                position={["relative", "absolute"]}
                                top={["0", "-42px"]}
                                flexDirection={"row"}
                                alignItems={"center"}
                                justifyContent={"end"}
                                zIndex={999}
                                w={'100%'}

                            >
                                <Menu>
                                    <Text textStyle={textStyle["body.medium.light"]}>Sort by</Text>
                                    <MenuButton
                                        as={Button}
                                        size="sm"
                                        variant="outline"
                                        rightIcon={<BsChevronDown />}
                                        ml={2}
                                        isDisabled={isPosting || isGenerating || isGeneratingAutoReply}
                                    >
                                        <Text maxW="200px" noOfLines={1} wordBreak="break-all">
                                            {sortby}
                                        </Text>
                                    </MenuButton>
                                    <MenuList maxH="215px" overflow="scroll">
                                        {sortValuesByMode["reply-to-comment"].map((value) => (
                                            <MenuItem key={value} onClick={() => {
                                                onSortCallback(value);
                                                setSortby(value);
                                            }}>
                                                {value}
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </Menu>
                            </Flex>
                        }
                        <Box
                            position="relative"
                            layerStyle={layerStyle["bg.border.rounded"]}
                            p={4}
                        >
                            <TweetComposer
                                ref={refComposer}
                                disableImage={true}
                                disableRichText={false}
                                disableSnippets={false}
                                disableGif={true}
                                disableHeader={true}
                                mode={"engage"}
                                submit={sendReply}
                                onUpdate={onUpdate}
                                initText={comment?.reply}
                                // isFocused={isFocused}
                                // removeTweet={removeTweet}
                                disableThread={true}
                                disableAiContinue={true}
                                disableSuggestion={true}
                            />
                            <Box mt={0} display="flex" justifyContent="flex-end">
                                <Box mr={3}>
                                    <CardList
                                        cards={cards}
                                        onClick={generateReplies}
                                        isLoading={isGeneratingAutoReply}
                                    />
                                </Box>

                                <Tooltip label={replyTootlTip} shouldWrapChildren>
                                    <Button
                                        ml={5}
                                        isLoading={isPosting}
                                        isDisabled={
                                            isReplied ||
                                            comment.isReplied ||
                                            !canPostComments
                                        }
                                        variant="primary"

                                        onClick={sendReply}
                                    >
                                        Reply
                                    </Button>
                                </Tooltip>
                            </Box>
                        </Box>
                    </Flex>
                </Flex>
            }
        </>
    )
}